import html from "../assets/img/icon/html.png";
import css from "../assets/img/icon/css.png";
import js from "../assets/img/icon/js.svg";
import bootstrap from "../assets/img/icon/bootstrap.svg";
import figma from "../assets/img/icon/figma.png";
import express from "../assets/img/icon/express.png";
import git from "../assets/img/icon/git.png";
import material from "../assets/img/icon/material.svg";
import node from "../assets/img/icon/node.svg";
import postgres from "../assets/img/icon/postgres.png";
import pwa from "../assets/img/icon/pwa.png";
import react from "../assets/img/icon/react.svg";
import sass from "../assets/img/icon/sass.svg";
import sequelize from "../assets/img/icon/sequelize.png";
import vue from "../assets/img/icon/vue.svg";
import mongo from "../assets/img/icon/mongodb.png";
import docker from "../assets/img/icon/docker.png";
import type from "../assets/img/icon/type.png";
import rabbitmq from "../assets/img/icon/rabbitmq.png";
import directus from "../assets/img/icon/directus.png";
import reactN from "../assets/img/icon/react.svg";
import redux from "../assets/img/icon/redux.png";
import aws from "../assets/img/icon/aws.png";
import python from "../assets/img/icon/python.png";

const datos = [
  { title: 'HTML5', url: html },
  { title: 'CSS', url: css },
  { title: 'JAVA SCRIPT', url: js },
  { title: 'BOOTSTRAP', url: bootstrap },
  { title: 'FIGMA', url: figma },
  { title: 'EXPRESS', url: express },
  { title: 'GIT', url: git },
  { title: 'MATERIAL UI', url: material },
  { title: 'NODE', url: node },
  { title: 'SQL DB', url: postgres },
  { title: 'PWA', url: pwa },
  { title: 'REACT', url: react },
  { title: 'SASS', url: sass },
  { title: 'SAQUELIZE', url: sequelize },
  { title: 'VUE', url: vue },
  { title: 'MONGODB', url: mongo },
  { title: 'DOCKER', url: docker },
  { title: 'TYPES CRIPT', url: type },
  { title: 'RABBIT MQ', url: rabbitmq },
  { title: 'DIRECTUS', url: directus },
  { title: 'REACT NATIVE', url: reactN },
  { title: 'REDUX', url: redux },
  { title: 'AWS', url: aws },
  { title: 'PYTHON', url: python },
];

export default datos